import React from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';
import ReturnIcon from './return-icon';

type Props = {
	onClick: () => void;
	isEmpty: boolean;
	hasValidationError: boolean;
};

export const CreateButton = ({ onClick, isEmpty, hasValidationError }: Props) => {
	const { formatMessage } = useIntl();
	const isDisabled = isEmpty || hasValidationError;
	let tooltipContent = formatMessage(messages.createButtonTooltip, {
		icon: () => <ReturnIcon />,
	});

	if (isEmpty) {
		tooltipContent = formatMessage(messages.createButtonTooltipContentEmpty);
	} else if (hasValidationError) {
		tooltipContent = undefined;
	}

	return (
		<Box
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
			xcss={xcss({
				marginLeft: 'space.100',
			})}
		>
			<Tooltip content={tooltipContent}>
				<Button
					appearance="primary"
					spacing="compact"
					type="submit"
					isDisabled={isDisabled}
					onClick={(e: React.MouseEvent) => {
						e.preventDefault();
						onClick();
					}}
				>
					{formatMessage(messages.createButtonLabel)}
				</Button>
			</Tooltip>
		</Box>
	);
};
